import styled from 'styled-components';
import { CheckStreamlineCoreLine } from '@upright/ui/icons';

/** Locale-aware currency formatting — places symbol correctly for each currency (e.g. $1490 vs 1490 €) */
const currencyToLocaleMap: Record<string, string> = {
  eur: 'fi-FI',
  usd: 'en-US',
};

export const formatPriceLabel = ({ amount, currency }: { amount: number; currency: string }) => {
  const locale = currencyToLocaleMap[currency.toLowerCase()];
  if (locale) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency.toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  }
  return `${amount}`;
};

/** Consistent-size checkmark icon — flex-shrink: 0 prevents the icon from being squeezed by flex layout */
export const CheckIcon = () => (
  <CheckIconWrapper>
    <CheckStreamlineCoreLine width={16} height={16} />
  </CheckIconWrapper>
);

export const CheckIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;

  svg {
    width: 16px;
    height: 16px;
  }
`;
